import React from 'react'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { navigate } from 'gatsby'

import './content-stack.css'

export const ContentStack = ({ item }) => {
    return (
        <div className="content-blog-picker-stack">
            {item.contentBlogPicker.map((subitem, index) => {
              const formattedDate = new Date(subitem.publishDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit",
              });
              return (
                <div key={index}>
                  <div className="relative content mb-10">
                    <div className="absolute top-0 left-0 w-full flex justify-between head">
                      <div>{subitem.parentCategory.categoryName}</div>
                      {subitem.includeDateDisplayInTheContentBlogPicker && <div>{formattedDate}</div>}
                    </div>
                    <div className="grid col-5-3 col-1-md">
                      <div className="relative inner-content">
                        <h4 className='cursor-pointer' onClick={()=>navigate(`/${subitem.parentCategory.slugId}/${subitem.blogPostUrlSlug}`)}>{subitem.title}</h4>
                        {documentToReactComponents(JSON.parse(subitem.excerpt.raw))}
                      </div>
                      <div
                        className="image cursor-pointer flex justify-center align-center"
                        style={{
                          backgroundColor: subitem.thumbnailColor || '#fff'
                        }}
                        onClick={()=>navigate(`/${subitem.parentCategory.slugId}/${subitem.blogPostUrlSlug}`)}
                      >
                        <img className='mb-0' src={subitem.thumbnailImage.gatsbyImageData.images.fallback.src} alt={subitem.title || 'Blog Picker Media Item'} style={{  height: '100%' }} />
                      </div>
                    </div>
                    {/* <div className="absolute bottom-0 left-0 w-full flex justify-between foot">
                      <div></div>
                      <div><a href={`/${subitem.parentCategory.slugId}/${subitem.blogPostUrlSlug}`}>Read More</a></div>
                    </div> */}
                  </div>
                </div>
              );
            })}
        </div>
    )
}